<template>
  <v-navigation-drawer :value="drawer" app clipped color="grey lighten-3" right>
    <v-list>
      <span v-for="navItem in navList" :key="navItem.text">
        <!-- NAV-ITEM HAS SUB-ITEMS -->
        <v-list-group
          v-if="navItem.subItems && can(navItem.permission)"
          no-action
          color="secondary"
        >
          <template #prependIcon>
            <v-icon color="secondary">{{ navItem.icon }}</v-icon>
          </template>

          <template #activator>
            <v-list-item-content>
              <v-list-item-title class="grey--text text--darken-2">{{ navItem.text }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            ripple
            link
            :to="subItem.link"
            v-for="subItem in navItem.subItems"
            :key="subItem.title"
            dense
            class="pr-5"
          >
            <v-list-item-action class="ml-2">
              <v-icon color="secondary lighten-2">mdi-subdirectory-arrow-left</v-icon>
            </v-list-item-action>
            
            <v-list-item-content>
              <v-list-item-title class="grey--text text--darken-2">{{ subItem.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- SINGLE NAV-ITEM -->
        <v-list-item v-else-if="can(navItem.permission)" link color="secondary" :to="navItem.link">
          <v-list-item-action>
            <v-icon color="secondary">{{ navItem.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="grey--text text--darken-2">{{ navItem.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </span>
    </v-list>
  </v-navigation-drawer>
</template>


<script>
export default {
  name: 'side-bar',
  props: ['drawer'],


  data: function () {
    return {
      navList: [
        {
          link: '/home',
          icon: 'mdi-monitor-dashboard',
          text: 'الرئيسية',
          permission: 'no-permission',
        },
        {
          link: '/categories',
          icon: 'mdi-sitemap',
          text: 'الأقسام',
          subItems: [],
          permission: 'category.show',
        },
        {
          link: '/articles',
          icon: 'mdi-post',
          text: 'المواد',
          subItems: [],
          permission: 'article.show',
        },
        {
          link: '/news',
          icon: 'mdi-newspaper',
          text: 'الأخبار',
          permission: 'news.show',
        },
        {
          link: '/carousel',
          icon: 'mdi-view-carousel-outline',
          text: 'العارض الديناميكي',
          permission: 'others.carousel',
        },
        {
          link: '/authors',
          icon: 'mdi-tie',
          text: 'المؤلفون',
          permission: 'article.show',
        },
        {
          link: '/translators',
          icon: 'mdi-translate',
          text: 'المترجمون',
          permission: 'article.show',
        },
        {
          link: '/contact-us',
          icon: 'mdi-forum',
          text: 'رسائل التواصل',
          permission: 'message.show',
        },
        {
          link: '/emails',
          icon: 'mdi-email',
          text: 'القائمة البريدية',
          permission: 'message.show',
        },
        {
          link: '/likes',
          icon: 'mdi-thumb-up-outline',
          text: 'التفاعل مع المواد',
          permission: 'message.show',
        },
        {
          link: '/problem-reports',
          icon: 'mdi-alert-circle',
          text: 'المشكلات',
          permission: 'report.show',
        },
        {
          link: '/admins',
          icon: 'mdi-account-tie',
          text: 'المشرفين',
          permission: 'admin.show',
        },
        {
          icon: 'mdi-monitor',
          text: 'إدارة المحتوي',
          permission: 'admin.show',
          subItems: [
            {
              link: '/contents/external-website-links',
              icon: 'mdi-open-in-new',
              text: 'روابط خارجية'
            },
            {
              link: '/contents/pages/about-us',
              icon: 'mdi-forum',
              text: 'صفحات الموقع'
            },
            {
              link: '/contents/contact-info',
              icon: 'mdi-web',
              text: 'بيانات التواصل'
            },
            {
              link: '/contents/settings',
              icon: 'mdi-cogs',
              text: 'إعدادات عامة'
            }
          ]
        }
      ]
    }
  },


  created() {
    this.setCategoriesSubItems();
  },


  methods: {
    /**
     * set the sub-items of /categories & /articles nav-item-groups
     */
    setCategoriesSubItems() {
      this.axios.get('/admin/categories')
        .then((response) => {
          this.navList.forEach((navItem, index) => {
            // set the sub-items of /categories nav-item-group
            if (navItem.link === '/categories')  {
              response.data.forEach((category) => {
                this.navList[index].subItems.push({
                  link: `/categories/${category.id}/sections`,
                  text: category.name
                });
              })
            }
            // set the sub-items of /articles nav-item-group
            else if (navItem.link === '/articles')  {
              response.data.forEach((category) => {
                this.navList[index].subItems.push({
                  link: `/categories/${category.id}/articles`,
                  text: category.name
                });
              })
            }
          });
        });
    }
  }
}
</script>